<div class="fpf-page">

  <div *ngIf="loading" class="fpf-state">
    <div class="fpf-spinner"></div>
  </div>

  <div *ngIf="error && !loading" class="fpf-state">
    <p class="fpf-error">{{ 'fee.payment_form.load_error' | translate }}</p>
  </div>

  <ng-container *ngIf="!loading && !error">
  <ng-container *ngIf="page; let page">
  <ng-container *ngIf="record; let record">

    <div class="fpf-header fpf-header--outside">
      <button type="button" class="back-button" (click)="goBack()" aria-label="Back">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="#12314F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <img src="assets/svg/scanMeHeaderLogoNew.svg" alt="ScanMe" class="fpf-logo"
           onerror="this.style.display='none'">
    </div>

    <section class="fpf-card">

        <div class="fpf-info-list" *ngIf="!showOtherPaymentMethods">
          <div class="fpf-row">
            <span class="fpf-label">{{ 'user_card.name' | translate }}</span>
            <span class="fpf-value">{{ page.memberName }}</span>
          </div>
          <div class="fpf-row" *ngIf="page.emergencyContactName">
            <span class="fpf-label">{{ 'fee.emergency_contact' | translate }}</span>
            <span class="fpf-value">{{ page.emergencyContactName }}</span>
          </div>
          <div class="fpf-row" *ngIf="page.industryName">
            <span class="fpf-label">{{ 'fee.payment_form.industry_name' | translate }}</span>
            <span class="fpf-value">{{ page.industryName }}</span>
          </div>
          <div class="fpf-row" *ngIf="subgroup?.groupName">
            <span class="fpf-label">{{ 'fee.group' | translate }}</span>
            <span class="fpf-value">{{ subgroup?.groupName }}</span>
          </div>
          <div class="fpf-row" *ngIf="subgroup?.name">
            <span class="fpf-label">{{ 'fee.subgroup' | translate }}</span>
            <span class="fpf-value">{{ subgroup?.name }}</span>
          </div>
          <div class="fpf-row">
            <span class="fpf-label">{{ 'fee.payment_form.pay_date' | translate }}</span>
            <span class="fpf-value">{{ record.month | localizedMonth }}</span>
          </div>
          <div class="fpf-row">
            <span class="fpf-label">{{ 'fee.price' | translate }}</span>
            <span class="fpf-value">{{ record.price | number }} ֏</span>
          </div>
          <div class="fpf-row" *ngIf="hasSale">
            <span class="fpf-label">{{ 'fee.payment_form.sale' | translate }}</span>
            <span class="fpf-value">{{ discountLabel }}</span>
          </div>
          <div class="fpf-row" *ngIf="hasDue">
            <span class="fpf-label">{{ 'fee.due' | translate }}</span>
            <span class="fpf-value">{{ periodDue | number }} ֏</span>
          </div>
          <div class="fpf-row fpf-row--total">
            <span class="fpf-label">{{ 'fee.total' | translate }}</span>
            <span class="fpf-value fpf-total">{{ record.due | number }} ֏</span>
          </div>
        </div>

        <div class="fpf-info-list" *ngIf="showOtherPaymentMethods">
          <div class="fpf-row">
            <span class="fpf-label">{{ 'fee.price' | translate }}</span>
            <span class="fpf-value">{{ record.price | number }} ֏</span>
          </div>
          <div class="fpf-row" *ngIf="hasSale">
            <span class="fpf-label">{{ 'fee.payment_form.sale' | translate }}</span>
            <span class="fpf-value">{{ discountLabel }}</span>
          </div>
          <div class="fpf-row" *ngIf="hasDue">
            <span class="fpf-label">{{ 'fee.due' | translate }}</span>
            <span class="fpf-value">{{ periodDue | number }} ֏</span>
          </div>
          <div class="fpf-row fpf-row--total">
            <span class="fpf-label">{{ 'fee.total' | translate }}</span>
            <span class="fpf-value fpf-total">{{ record.due | number }} ֏</span>
          </div>
        </div>

        <div class="fpf-amount-box" *ngIf="!showOtherPaymentMethods">
          <img src="assets/card-live-preview/dram.svg" alt="֏" class="fpf-dram"
               onerror="this.onerror=null;this.src='';this.alt='֏'">
          <input
            class="fpf-amount-input"
            type="text"
            inputmode="numeric"
            pattern="[1-9][0-9]*"
            [value]="payableAmountInput"
            [readonly]="!isAmountEditable"
            [attr.aria-invalid]="!canSubmitPayment"
            (keydown)="onAmountKeyDown($event)"
            (paste)="onAmountPaste($event)"
            (input)="onAmountInput($event)"
          />
        </div>

        <div class="fpf-share-panel" *ngIf="!showOtherPaymentMethods">
          <p class="fpf-share-title">{{ 'fee.payment_form.share_with_friend' | translate }}</p>
          <div class="fpf-share-actions">
            <button class="fpf-share-btn" type="button" (click)="showQr()">
              <span class="fpf-btn-icon">
                <img src="assets/svg/qr-icon.svg" alt="QR">
              </span>
              <span>{{ 'fee.payment_form.show_qr' | translate }}</span>
            </button>
            <button class="fpf-share-btn" type="button" (click)="shareLink()">
              <span class="fpf-btn-icon">
                <img src="assets/svg/share-icon.svg" alt="Share">
              </span>
              <span>{{ 'fee.payment_form.share_link' | translate }}</span>
            </button>
          </div>
          <div class="fpf-or-divider">{{ 'fee.payment_form.or' | translate }}</div>
          <div class="fpf-primary-actions">
            <button
              type="button"
              class="fpf-apple-pay-btn"
              [disabled]="paying || !canSubmitPayment"
              (click)="openOtherPaymentView()"
            >
              <svg class="fpf-apple-pay-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
              </svg>
              <span>{{ 'fee.pay' | translate }}</span>
            </button>
            <button class="fpf-other-btn" type="button" (click)="openOtherPaymentView()" [disabled]="paying || !canSubmitPayment">
              {{ 'fee.payment_form.other_payment' | translate }}
            </button>
          </div>
        </div>

      <div class="fpf-amount-box" *ngIf="showOtherPaymentMethods">
          <img src="assets/card-live-preview/dram.svg" alt="֏" class="fpf-dram"
               onerror="this.onerror=null;this.src='';this.alt='֏'">
          <input
            class="fpf-amount-input"
            type="text"
            inputmode="numeric"
            pattern="[1-9][0-9]*"
            [value]="payableAmountInput"
            [readonly]="!isAmountEditable"
            [attr.aria-invalid]="!canSubmitPayment"
            (keydown)="onAmountKeyDown($event)"
            (paste)="onAmountPaste($event)"
            (input)="onAmountInput($event)"
          />
      </div>

      <div class="fpf-payment-panel fpf-payment-panel--open" *ngIf="showOtherPaymentMethods">
          <span class="fpf-transfer-title">{{ 'fee.payment_form.transfer_with' | translate }}</span>

          <div class="fpf-recurring-toggle">
            <span class="fpf-recurring-label">{{ 'fee.payment_form.recurring_payment' | translate }}</span>
            <label class="fpf-toggle">
              <input
                type="checkbox"
                [checked]="recurringPaymentEnabled"
                (change)="onRecurringPaymentToggle($any($event.target).checked)"
              />
              <span class="fpf-toggle-ui"></span>
            </label>
          </div>
          <p *ngIf="recurringPaymentEnabled" class="fpf-recurring-note">
            {{ 'fee.payment_form.recurring_payment_note' | translate }}
          </p>

          <p *ngIf="payError" class="fpf-pay-error">{{ 'fee.payment_form.payment_failed' | translate }}</p>

          <button class="fpf-method-btn fpf-method-btn--card" (click)="payWithNewCard()" [disabled]="paying || !canSubmitPayment">
            <span>{{ 'fee.payment_form.pay_with_new_credit_card' | translate }}</span>
            <span class="fpf-plus">+</span>
          </button>
          <ng-container *ngFor="let card of savedCards">
            <button class="fpf-method-btn fpf-method-btn--card fpf-method-btn--saved" (click)="payWithSavedCard(card.cardHolderId)" [disabled]="paying || !canSubmitPayment">
              <span>{{ 'fee.credit_card_masked' | translate:{ digits: maskCardNumber(card.cardNumber) } }}</span>
              <span class="fpf-card-icons">
                <img class="fpf-credit-card-logo" src="assets/payment-type/credit-card.svg" alt="Credit Card">
              </span>
            </button>
          </ng-container>

          <div class="fpf-method-grid" [class.fpf-method-grid--disabled]="recurringPaymentEnabled">
            <button class="fpf-method-btn" (click)="payWithNewCard(true)" [disabled]="isAlternatePaymentMethodDisabled">
              <img [src]="getLogoUrl('APPLE_PAY', 'assets/payment-type/apple-pay.svg')" alt="Apple Pay">
            </button>
            <button class="fpf-method-btn" [disabled]="true">
              <img [src]="getLogoUrl('GOOGLE_PAY', 'assets/payment-type/google-pay.svg')" alt="Google Pay">
            </button>
            <button class="fpf-method-btn" (click)="payWithIdram()" [disabled]="isAlternatePaymentMethodDisabled">
              <img [src]="getLogoUrl('IDRAM', 'assets/payment-type/idram.svg')" alt="Idram">
            </button>
            <button class="fpf-method-btn" (click)="payWithEasyWallet()" [disabled]="isAlternatePaymentMethodDisabled">
              <img [src]="getLogoUrl('EASY_WALLET', 'assets/payment-type/easy-wallet.svg')" alt="Easy Wallet">
            </button>
            <button class="fpf-method-btn" (click)="payWithTelcell()" [disabled]="isAlternatePaymentMethodDisabled">
              <img [src]="getLogoUrl('TELCELL', 'assets/payment-type/telcell.svg')" alt="Telcell">
            </button>
            <button class="fpf-method-btn" (click)="payWithFastshift()" [disabled]="isAlternatePaymentMethodDisabled">
              <img [src]="getLogoUrl('FASTSHIFT', 'assets/payment-type/fastshift.svg')" alt="Fastshift">
            </button>
            <button class="fpf-method-btn" [disabled]="true">
              <img [src]="getLogoUrl('INECO_PAY', 'assets/payment-type/ineco-pay.svg')" alt="Ineco Pay">
            </button>
            <button class="fpf-method-btn" (click)="payWithMyPay()" [disabled]="isAlternatePaymentMethodDisabled">
              <img [src]="getLogoUrl('MY_PAY', 'assets/payment-type/my-pay.svg')" alt="My Pay">
            </button>
            <button class="fpf-method-btn" [disabled]="true">
              <img [src]="getLogoUrl('BANK_OF_GEORGIA', 'assets/payment-type/bank-of-georgia.svg')" alt="Bank of Georgia">
            </button>
            <button class="fpf-method-btn" [disabled]="true">
              <img [src]="getLogoUrl('IO_MONEY', 'assets/payment-type/io-money.svg')" alt="IO Money">
            </button>
            <button class="fpf-method-btn" [disabled]="true">
              <img [src]="getLogoUrl('SBER_BANK', 'assets/payment-type/sber-bank.svg')" alt="Sber Bank">
            </button>
            <button class="fpf-method-btn" [disabled]="true">
              <img [src]="getLogoUrl('T_BANK', 'assets/payment-type/t-bank.svg')" alt="T Bank">
            </button>
          </div>
      </div>
    </section>

  </ng-container>
  </ng-container>
  </ng-container>

</div>
